module.exports = __webpack_public_path__ + "assets/google-ads.d843c5c4.svg";